import { Icon, colors, mixin } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { ItemRenderProps } from "../types"

export const StyledHandle = styled.div`
  padding: 0 1rem;
  align-self: stretch;
  display: flex;

  :hover {
    ${mixin.clickable};
  }
`

export const HandleIcon = styled(Icon)<ItemRenderProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ isSelected }) => (isSelected ? "white" : colors.textMedium)};

  ${({ isBeingDragged, isDraggingOver }) => {
    if (isBeingDragged) {
      return
    } else if (isDraggingOver) {
      return css`
        display: none;
      `
    } else {
      return css`
        transition: visibility 0.1s;
        visibility: hidden;
        div:hover > div > & {
          visibility: visible;
        }
      `
    }
  }};
`
